import React, { useState } from 'react'
import { Button } from 'src/components/Ant'
import { Form, message as notification, Modal } from 'antd'
import { Formik } from 'formik'
import { useSelector } from 'react-redux'
import * as Yup from 'yup'

import { RequestUserData, Nps } from 'src/types'
import api from 'src/services/api'

import { ApplicationState } from 'src/store'
import { Input } from 'src/components/Formik'
import findBasicApiResponseErrors from 'src/services/findBasicApiResponseErrors'

type Props = {
  posSave(nps: Nps): void
  toggle(): void
  visible: boolean
  userData?: RequestUserData
}

const initialValues = {
  justification: '',
  rate: 10
}

function NpsModal({ posSave, toggle, userData, visible }: Props) {
  const { me } = useSelector((state: ApplicationState) => ({
    me: state.me
  }))
  const [loading, setLoading] = useState(false)

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={Yup.object().shape({
        justification: Yup.string()
      })}
      onSubmit={async values => {
        try {
          setLoading(true)

          const response = await api.post<{ requestnps: Nps[] }>(
            `organizations/${me.organization?.organization_id}/resources/request_nps`,
            {
              request_nps: [
                {
                  request_id: userData.request_id,
                  request_user_data_id: userData.request_user_data_id,
                  organization_id: me.organization?.organization_id,
                  message: values.justification,
                  rate: values.rate,
                  status: 'UNDERWAY',
                  nps_type: 'GENERAL'
                }
              ]
            }
          )

          if (response.ok) {
            setTimeout(() => {
              posSave(response.data.requestnps[0])
            }, 500)
            return
          }

          const message = findBasicApiResponseErrors(response)
          notification.error(message)
        } catch (e) {
          notification.error(e.message)
          // dispatch(GeneralActions.setErrorMessage(e.message))
        } finally {
          toggle()
          setLoading(false)
        }
      }}
      validateOnBlur={false}
      render={formikProps => (
        <Form onSubmit={formikProps.handleSubmit}>
          <Modal
            closable={!loading}
            maskClosable={!loading}
            width={600}
            onCancel={toggle}
            footer={[
              <Button
                disabled={loading}
                key="cancel"
                onClick={toggle}
                title="common.actions.cancel"
                type="default"
              />,
              <Button
                disabled={loading}
                {...{ loading }}
                key="submit"
                onClick={() => formikProps.submitForm()}
                title="common.actions.save"
              />
            ]}
            title="NPS"
            visible={visible}
          >
            Em uma escala de 1 a 10 quanto você recomendaria o toodo a um amigo
            ou familiar?
            <br />
            <br />
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center'
              }}
            >
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(item => (
                <div
                  key={item}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginRight: 8
                  }}
                >
                  <Button
                    onClick={() => formikProps.setFieldValue('rate', item)}
                    type="default"
                    style={{
                      background: `#${
                        item < 7 ? 'ec2324' : item < 9 ? 'fec408' : '42be45'
                      }`,
                      border: `1px solid #${
                        item < 7 ? 'ec2324' : item < 9 ? 'fec408' : '42be45'
                      }`,
                      color: '#fff',
                      width: 40,
                      height: 40,
                      alignItems: 'center',
                      display: 'flex',
                      justifyContent: 'center'
                    }}
                  >
                    {item}
                  </Button>
                  <div
                    style={{
                      marginTop: 4,
                      background:
                        item === formikProps.values.rate
                          ? `#${
                              item < 7
                                ? 'ec2324'
                                : item < 9
                                ? 'fec408'
                                : '42be45'
                            }`
                          : '#fff',
                      borderRadius: 8,
                      width: 8,
                      height: 8
                    }}
                  />
                </div>
              ))}
            </div>
            <Input
              autoFocus
              formikProps={formikProps}
              label="web.assignment.billing.form.observation.title"
              name="justification"
            />
          </Modal>
        </Form>
      )}
    />
  )
}

export default NpsModal
